export const isEditableTarget = (target) => (
  ['INPUT', 'TEXTAREA', 'SELECT'].includes(target?.tagName) || target?.isContentEditable
);
